import { loading, success, reset, handleErrorException } from 'State/actions';

import * as types from './types';

export const getConfiguration = () => {
  return async (dispatch, getState, MPWWebApi) => {
    try {
      dispatch(
        loading(types.POWERSCHOOL_EXPORT_GETCONFIGURATION_LOADING, true)
      );

      const response = await MPWWebApi.getGeneric(
        `sisintegration/powerschool/configuration`
      );

      dispatch(
        success(
          types.POWERSCHOOL_EXPORT_GETCONFIGURATION_SUCCESS,
          response.data.Data
        )
      );
    } catch (error) {
      dispatch(
        handleErrorException(
          error,
          types.POWERSCHOOL_EXPORT_GETCONFIGURATION_ERROR,
          {
            Title: 'Error',
            Message: 'Unable to get PowerSchool integration configuration.',
          }
        )
      );
    } finally {
      dispatch(
        loading(types.POWERSCHOOL_EXPORT_GETCONFIGURATION_LOADING, false)
      );
    }
  };
};

export const postSaveConfiguration = (values) => {
  return async (dispatch, getState, MPWWebApi) => {
    try {
      dispatch(
        loading(types.POWERSCHOOL_EXPORT_POSTSAVECONFIGURATION_LOADING, true)
      );

      const response = await MPWWebApi.postGenericInsertUpdate(
        `sisintegration/powerschool/configuration`,
        values
      );

      await dispatch(getConfiguration());

      dispatch(
        success(
          types.POWERSCHOOL_EXPORT_POSTSAVECONFIGURATION_SUCCESS,
          response.data.Data
        )
      );
    } catch (error) {
      dispatch(
        handleErrorException(
          error,
          types.POWERSCHOOL_EXPORT_POSTSAVECONFIGURATION_ERROR,
          {
            Title: 'Error',
            Message: 'Unable to save PowerSchool configuration.',
          }
        )
      );
    } finally {
      dispatch(
        loading(types.POWERSCHOOL_EXPORT_POSTSAVECONFIGURATION_LOADING, false)
      );
    }
  };
};

export const clearPostSaveConfigurationResult = () => {
  return async (dispatch) => {
    dispatch(
      reset(types.POWERSCHOOL_EXPORT_POSTSAVECONFIGURATION_SUCCESS, null)
    );
    dispatch(reset(types.POWERSCHOOL_EXPORT_POSTSAVECONFIGURATION_ERROR, null));
  };
};

// export const postTestConnection = (values) => {
//   return async (dispatch, getState, MPWWebApi) => {
//     try {
//       dispatch(
//         loading(types.POWERSCHOOL_EXPORT_POSTTESTCONNECTION_LOADING, true)
//       );

//       const response = await MPWWebApi.postGenericInsertUpdate(
//         `sisintegration/powerschool/testftpconnection`,
//         values
//       );

//       dispatch(
//         success(
//           types.POWERSCHOOL_EXPORT_POSTTESTCONNECTION_SUCCESS,
//           response.data.Data
//         )
//       );
//     } catch (error) {
//       dispatch(
//         handleErrorException(
//           error,
//           types.POWERSCHOOL_EXPORT_POSTTESTCONNECTION_ERROR,
//           {
//             Title: 'Error',
//             Message: 'Unable to test SFTP connection.',
//           }
//         )
//       );
//     } finally {
//       dispatch(
//         loading(types.POWERSCHOOL_EXPORT_POSTTESTCONNECTION_LOADING, false)
//       );
//     }
//   };
// };

// export const clearPostTestConnectionResult = () => {
//   return (dispatch) => {
//     dispatch(reset(types.POWERSCHOOL_EXPORT_POSTTESTCONNECTION_SUCCESS, null));
//     dispatch(reset(types.POWERSCHOOL_EXPORT_POSTTESTCONNECTION_ERROR, null));
//   };
// };

export const postExport = () => {
  return async (dispatch, getState, MPWWebApi) => {
    try {
      dispatch(loading(types.POWERSCHOOL_EXPORT_POSTEXPORT_LOADING, true));

      const response = await MPWWebApi.postGenericInsertUpdate(
        `sisintegration/powerschool/export`
      );

      //this is needed so that "HasManualExportBeenRun" will still be true if
      //the user changes the config after exporting. this is desired because the
      //point of checking the manual export is only to make sure the directory
      //exists, not to test any credentials
      await dispatch(getConfiguration());

      dispatch(
        success(types.POWERSCHOOL_EXPORT_POSTEXPORT_SUCCESS, response.data.Data)
      );
    } catch (error) {
      dispatch(
        handleErrorException(error, types.POWERSCHOOL_EXPORT_POSTEXPORT_ERROR, {
          Title: 'Error',
          Message: 'Unable to perform export.',
        })
      );
    } finally {
      dispatch(loading(types.POWERSCHOOL_EXPORT_POSTEXPORT_LOADING, false));
    }
  };
};

export const clearPostExportResult = () => {
  return (dispatch) => {
    dispatch(reset(types.POWERSCHOOL_EXPORT_POSTEXPORT_SUCCESS, null));
    dispatch(reset(types.POWERSCHOOL_EXPORT_POSTEXPORT_ERROR, null));
  };
};



// WEBPACK FOOTER //
// ./src/pages/powerschoolintegration/powerschoolexport/state/actions.js